import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Mono numerals / timestamps / initials (not uppercased). Callers pass size, color. */
export const Mono = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-accent', p.className)} />
);
